import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeConsumer, HomeContext, HomeProvider } from './HomeContext';
import { useRecoilState } from 'recoil';
import { HeaderAtom } from '../../atoms/atomSample';
import {
    MainContainer,
    Title,
    Subtitle,
    Description,
    Button,
    Image, ButtonContainer, SecondaryButton, MainButton
} from './HomeStyles';

import logoimage from '../../static/CineChain.png';

export default function Home() {
  const navigate = useNavigate(); // useNavigate 훅 사용
  // const { lotGridRows, setLotGridRows } = useContext(HomeContext);
  const [HeaderItem, setHeaderItem] = useRecoilState(HeaderAtom);
  const [item_sample, setItem_sample] = useState();

  const getItemSample = (item_sample) => {
    fetch(`/test/getItemSample?item_sample=${item_sample}`, { credentials: 'include' })
      .then((res) => res.json())
      .then((msg) => setItem_sample(msg))
      .catch(err => alert('Error' + err));
  }

  return (
    <MainContainer>
        <Image src={logoimage} alt="CineChain" />
      <Description>
        <p>씨네체인은 빠르고 안전한 대행거래 플랫폼입니다</p>
        <span>씨네체인은 저렴하게 구매를 하고싶어하는 요청자와쌓아둔 쿠폰이나 포인트를<p/>
          현금화할 수단이 막막한 고객 여러분들의 대행자 서비스를만들어 대행 서비스를 진행하는데 있어 도와드립니다</span>
        
        </Description>
        <ButtonContainer>
            <MainButton onClick={() => navigate('/Tiketting/AgentUserOrders')}>예매대행하러 가기</MainButton>
            <SecondaryButton onClick={() => navigate('/UsageGuide')}>이용안내</SecondaryButton>
            <SecondaryButton onClick={() => navigate('/WithdrawalGuide')}>출금안내</SecondaryButton>
            <SecondaryButton onClick={() => navigate('/CSCenter/Notices')}>고객센터</SecondaryButton>
            <SecondaryButton onClick={() => navigate('/AgentClass')}>대행자 클래스</SecondaryButton>
        </ButtonContainer>
      <HomeConsumer />
    </MainContainer>
  )
}

export function SubHome() {
  const { lotGridRows } = useContext(HomeContext);

  return (
    <div>
    </div>
  )
}
